import { render } from "./service-batch-auth.vue?vue&type=template&id=9232eb0a&scoped=true&ts=true"
import script from "./service-batch-auth.vue?vue&type=script&lang=ts"
export * from "./service-batch-auth.vue?vue&type=script&lang=ts"

import "./service-batch-auth.vue?vue&type=style&index=0&id=9232eb0a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9232eb0a"]])

export default __exports__